import { IBillingResult, IBillingPart } from "nodeDetails/types";
import { t } from "i18next";
import { UnixToDateConverter } from "common/DateConverter";

export const getDisplayBillingPeriod = (
  startTimestamp: number,
  endTimestamp: number
) => {
  const startDate = UnixToDateConverter(startTimestamp).format("L");
  // End date is 00:00:00 the next month so we need to remove one second for it to become the correct month.
  const endDate = UnixToDateConverter(endTimestamp)
    .subtract(1, "second")
    .format("L");

  return `${startDate} ${t("to")} ${endDate}`;
};

export const calculateTotal = (billingResult: IBillingResult) => {
  const totalPrice = billingResult.Parts.reduce(
    (totalPrice, part) => {
      const partTotalPrice = calculateBillingPartTotal(part);

      return {
        total: totalPrice.total + partTotalPrice.total,
        vat: totalPrice.vat + partTotalPrice.vat,
        rounding: totalPrice.rounding + partTotalPrice.rounding,
      };
    },
    { total: 0, vat: 0, rounding: 0 }
  );

  return totalPrice;
};

export const calculateBillingPartTotal = (part: IBillingPart) =>
  part.Items.reduce(
    (totalPartPrice, item) => ({
      ...totalPartPrice,
      total: totalPartPrice.total + (item.Total || 0),
      vat: totalPartPrice.vat + (item.TotalVat || 0),
    }),
    { total: 0, vat: 0, rounding: part.Rounding || 0 }
  );

export const getQuantityUnitTranslation = (unit: string) => {
  const allQuantityUnits: Record<string, string> = {
    Units: t("billing-results.rate-units"),
    Days: t("days"),
    Months: t("months"),
    kW: t("kW"),
    kWh: t("kWh"),
    MW: t("MW"),
    MWh: t("MWh"),
    m3: t("m³"),
    C: t("°C"),
  };

  return allQuantityUnits[unit] || unit;
};

export const getRateUnitTranslation = (unit: string) => {
  const allRateUnits: Record<string, string> = {
    Unit: t("billing-results.rate-unit"),
    Day: t("day"),
    Month: t("month"),
    Year: t("year"),
    kW: t("kW"),
    kWh: t("kWh"),
    MW: t("MW"),
    MWh: t("MWh"),
    m3: t("m³"),
    C_year_m2: t("°C/year/m²"),
    m2_year: t("m²/year"),
  };

  return allRateUnits[unit] || unit;
};
